<!-- page title -->
<div class="page-title" *ngIf="false">
    <h2> KYC SCORE AUTOMATION (MASTER) </h2>
</div>



<app-breadcrumb [record]="totalRecords"></app-breadcrumb>

<!-- grid -->
<div class="border-box-shadow no-padding">
    <table mat-table [dataSource]="dataSource">
        <!-- Activity Column -->
        <ng-container matColumnDef="Perticular">
            <th mat-header-cell *matHeaderCellDef> Perticular </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Project Type Column -->
        <ng-container matColumnDef="Score">
            <th mat-header-cell *matHeaderCellDef> Kyc Score </th>
            <td mat-cell *matCellDef="let element" style=" width: 18%;">
                <!-- {{element.number}} -->
                <!-- <input matInput placeholder="kyc score" type="number" [value]="element.number" /> -->
                <mat-form-field appearance="outline" class="input-wrapper">
                    <mat-label>KYC Score</mat-label>
                    <input matInput placeholder="kyc score" type="number" [value]="element.number"
                        (blur)="kycScoreUpdate($event.target.value, element.id)" (keypress)="onlyChars($event)" />
                </mat-form-field>
            </td>
        </ng-container>




        <!-- action button -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let element">
                <button class="btn btn-info" (click)="UpdateKycScore()">Update</button>
            </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <br>



    <!-- system info need to add -->

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title style="color: white;">
                System info
            </mat-panel-title>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="logs">
            <!--created history-->
            <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef>{{'generalContractor.createdDateTimeCreatedBy'|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.created_date | date:'dd-MMM-yyyy HH:mm:ss
                    a'}}-{{element.created_name}} </td>
            </ng-container>
            <!--modified history-->
            <ng-container matColumnDef="modified">
                <th mat-header-cell *matHeaderCellDef> {{'generalContractor.modifiedDateTimeModifiedBy'|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.modified_by_date | date:'dd-MMM-yyyy HH:mm:ss
                    a'}}-{{element.modified_by_name}} </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedLogs"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedLogs;"></tr>
        </table>
    </mat-expansion-panel>


    <!---result not found -->
    <!-- <app-result-not-found [inputNotFound]="notFoundResult"></app-result-not-found> -->

</div>
